import React, { Component, StrictMode } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Form from './components/Form/Form';
import './CreateApp.scss';
import { SUCCESS, PROFILE_STEP_STATUSES, publicHash } from '../../utils/constants';

class CreateApp extends Component {
  static propTypes = {
    getAppImage: PropTypes.func.isRequired,
    appImage: PropTypes
      .shape({})
      .isRequired,
    appImageStatus: PropTypes.string.isRequired,
    getAppQuestions: PropTypes.func.isRequired,
    appQuestions: PropTypes
      .shape({})
      .isRequired,
    createApp: PropTypes.func.isRequired,
    appImageError: PropTypes.string.isRequired,
    createAppStatus: PropTypes.string.isRequired,
    createAppError: PropTypes.string.isRequired,
    updateProfileStatus: PropTypes.func.isRequired,
    history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
    profileStepStatus: PropTypes.string.isRequired,
    isFirstFlow: PropTypes.bool.isRequired,
    match: PropTypes.shape({}).isRequired,
    getApp: PropTypes.func.isRequired,
    updateApp: PropTypes.func.isRequired,
    currentEditableApp: PropTypes.shape({}).isRequired,
    updateAppStatus: PropTypes.string.isRequired,
    resetEditApp: PropTypes.func.isRequired,
    getApps: PropTypes.func.isRequired,
    createdAppId: PropTypes.number.isRequired,
    accessToken: PropTypes.string.isRequired,
    deleteApp: PropTypes.func.isRequired,
    deleteAppStatus: PropTypes.string.isRequired,
    deleteAppError: PropTypes.string.isRequired,
    deleteAppSuccess: PropTypes.string.isRequired,
    annulError: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    deleteApplication: PropTypes.func.isRequired,
  }

  static defaultProps = {
    isAdmin: false,
  }

  componentWillMount() {


  }
  componentDidMount() {
    const {
      history: { push }, profileStepStatus, isFirstFlow, match, getApp,

    } = this.props;
    if (isFirstFlow) {
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = () => {
        window.history.go(1);
      };

      if (profileStepStatus !== PROFILE_STEP_STATUSES.NO_APP) {
        push(`${publicHash}/app/create-campaign`);
      }
    }
    if (match.params.appId) {
      getApp({ appId: match.params.appId });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      createAppStatus,
      updateProfileStatus,
      updateAppStatus,
      history: { push },
      resetEditApp,
      createdAppId,
      currentEditableApp,
      isFirstFlow,
      getApps,
      deleteAppSuccess,
      annulError,
      deleteAppStatus,
    } = this.props;

    if (prevProps.createAppStatus !== createAppStatus && createAppStatus === SUCCESS) {
      if (isFirstFlow) {
        updateProfileStatus(PROFILE_STEP_STATUSES.NO_CAMPAIGN);
      } else {
        getApps({ projection: 'SHORT' });
        push(`${publicHash}/app/${createdAppId}/campaigns`);
      }
    }
    if (prevProps.updateAppStatus !== updateAppStatus && updateAppStatus === SUCCESS) {
      resetEditApp();
      getApps({ projection: 'SHORT' });
      push(`${publicHash}/app/${currentEditableApp.id}/campaigns`);
    }
    if (prevProps.deleteAppStatus !== deleteAppStatus && deleteAppStatus === SUCCESS) {
      resetEditApp();
      getApps({ projection: 'SHORT' });
      push(`${publicHash}/app`);
    }
    if (prevProps.deleteAppSuccess !== deleteAppSuccess && deleteAppSuccess === SUCCESS) {
      annulError();
      push(`${publicHash}/app/apps`);
    }
  }
  componentWillUnmount() {
    this.props.resetEditApp();
  }
  render() {
    const {
      getAppImage,
      appImage,
      appImageStatus,
      getAppQuestions,
      appQuestions,
      createApp,
      appImageError,
      createAppStatus,
      createAppError,
      currentEditableApp,
      updateApp,
      match,
      deleteApp,
      deleteAppStatus,
      deleteAppError,
      deleteAppSuccess,
      accessToken,
      annulError,
      isAdmin,
      deleteApplication,
    } = this.props;
    const createAppClassNames = classNames(['screen', 'create-app-screen']);
    // use access_token for not rerendering components on Logout and to not send requests.
    return (
      <StrictMode>
        <div className={createAppClassNames}>

          <div className="create-app-content">
            {!match.params.appId && <div className="main-label">Let’s add an app!</div> }
            {accessToken && <Form
              getAppImage={getAppImage}
              appImage={appImage}
              appImageStatus={appImageStatus}
              getAppQuestions={getAppQuestions}
              appQuestions={appQuestions}
              isAdmin={isAdmin}
              createApp={createApp}
              updateApp={updateApp}
              createAppStatus={createAppStatus}
              createAppError={createAppError}
              appImageError={appImageError}
              currentApp={currentEditableApp}
              deleteApp={deleteApp}
              deleteApplication={deleteApplication}
              deleteAppStatus={deleteAppStatus}
              deleteAppError={deleteAppError}
              deleteAppSuccess={deleteAppSuccess}
              annulError={annulError}
            /> }
          </div>
        </div>
      </StrictMode>
    );
  }
}

export default CreateApp;



// WEBPACK FOOTER //
// ./src/containers/CreateApp/CreateApp.js